import React, { useState, useRef } from 'react';
import { Box, Button, Card, Dialog, DialogTitle, DialogContent, Grid, IconButton, Typography } from '@mui/material';
import Header from "../Header";
import { styles } from '../../styles/styles';
import { DecorativeCorner } from '../../common/DecorativeCorner';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from "@mui/icons-material/Add";
import Footer from '../Footer';

const UploadImage = () => {
    const [open, setOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [expanded, setExpanded] = useState(false); 
    const fileInputRef = useRef(null);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const newImages = files.map(file => ({
            file,
            preview: URL.createObjectURL(file)
        }));
        setImages([...images, ...newImages]);
        setExpanded(true); 
    };

    const handleDeleteImage = (index) => {
        const newImages = [...images];
        URL.revokeObjectURL(newImages[index].preview);
        newImages.splice(index, 1);
        setImages(newImages);

        if (newImages.length === 0) {
            setExpanded(false); 
        }
    };

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    return (
        <>
            <Box>
                <Header />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleOpen}
                    sx={{
                        backgroundColor: "rgb(183, 113, 8)",
                        color: "white",
                        borderRadius: "10px",
                        padding: { xs: "8px 12px", sm: "15px 25px" },
                        fontSize: { xs: "12px", sm: "18px" },
                        mb: 2,
                        marginTop: { xs: "30%", sm: "10%" },
                        marginRight:{xs:"20px",sm:"7%"}
                    }}>
                    Add Photo
                </Button>
                
            </Box>

            <Card
                sx={{
                    ...styles.cardimage,
                    padding: { xs: 2, sm: "40px" },
                    height: {xs:expanded ? "auto" : "100px",sm:expanded ? "auto" : "400px"}, 
                    borderRadius: "5px",
                    overflow: "hidden",
                    transition: "height 0.3s ease",
                }}
            >
                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />

                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    multiple
                    accept="image/*"
                />

                <Grid container spacing={2}>
                    {images.map((image, index) => (
                        <Grid item xs={6} sm={3} key={index}>
                            <Box sx={{ position: 'relative' }}>
                                <img
                                    src={image.preview}
                                    alt={`preview ${index}`}
                                    style={{
                                        width: '290px',
                                        height: '290px',
                                        objectFit: 'cover',
                                        borderRadius: '4px'
                                    }}
                                />
                                <IconButton
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        color: 'white',
                                        backgroundColor: 'rgba(0,0,0,0.5)'
                                    }}
                                    onClick={() => handleDeleteImage(index)}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        </Grid>
                    ))}
                </Grid>

                {/* Upload Dialog */}
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle>Add Photo to Album</DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent>
                        <Box
                            sx={{
                                border: '2px dashed rgb(224, 141, 64)',
                                borderRadius: '4px',
                                p: 4,
                                textAlign: 'center',
                                cursor: 'pointer',
                                '&:hover': {
                                    backgroundColor: 'action.hover'
                                }
                            }}
                            onClick={triggerFileInput}
                        >
                            <CloudUploadIcon fontSize="large" sx={{ color: "rgb(224, 141, 64)" }} />
                            <Typography variant="h6">Drop your images here or browse</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Supported formats: PNG, JPG, JPEG
                            </Typography>
                        </Box>
                    </DialogContent>
                </Dialog>
            </Card>

            <Footer/>
        </>
    );
};

export default UploadImage;
